import axios from 'axios'
import { useRoute } from 'vue-router'

import { useAppStore } from '@/stores/AppStore'

const versionURL = `${import.meta.env.VITE_VUE_APP_ORIGINAL_URL}version.json`
const timeout = 300_000

export const appCheck = () => {
  const route = useRoute()

  const { getAppVersion } = useAppStore()

  let appRefreshInterval = setInterval(() => reloadApp(), timeout)
  const reloadApp = async () => {
    const appVersion = await actualAppVersion()
    const preventAppRefresh = route.matched.some((record) => record.meta.preventAppRefresh)
    if (getAppVersion && getAppVersion !== appVersion && !preventAppRefresh) {
      window.location.reload()
    }
    clearInterval(appRefreshInterval)
    appRefreshInterval = setInterval(() => reloadApp(), timeout)
  }
}

export const actualAppVersion = async () => {
  const { data } = await axios.get(versionURL)
  return data.actual_version
}
